import { Picture } from '../../../../domains/Picture/Picture';
import { YYYYMMDD } from '../../../../shared/utilities/date';
import { Agency } from '../../../agency/domain/types/Agency';
import { Destination } from '../../../destination/domain/types/destination';
import { PointOfInterest } from '../../../pointOfInterest/domain/types/PointOfInterest';
import { Brand } from '../../../shared/types/brand';
import { Price } from '../../../shared/types/Price';

export type ItineraryId = Brand<number, 'ItineraryId'>;

type TypeOfProfile =
    | {
          type: 'adults';
      }
    | {
          type: 'family';
          withYoungChildren: boolean;
          withTeenagers: boolean;
          withBabies: boolean;
          recommendedAge: RecommendedAgeType;
          recommendedPace: RecommendedPaceType;
      };

type RecommendedAgeType = 'from-0' | 'from-3' | 'from-6' | 'from-10' | 'from-12';

type RecommendedPaceType = 'calm' | 'balanced' | 'strong';

type AtypicalTransport = 'bike-tour' | 'camper-van' | 'cruise' | 'horse-riding-tour' | 'train';

export type Itinerary = {
    id: ItineraryId;
    slug: string;
    title: string;
    description: string;
    destination: Destination;
    agency: Agency;
    picture: Picture;
    rangeName: string;
    duration: number;
    highlights: string[];
    startingPrice: Price;
    isGIR: boolean;
    services: ItineraryServices;
    groupDeparture: GroupDeparture;
    tourismTypes: string[];
    pointsOfInterest: PointOfInterest[];
    activityTypes: string[];
    typeOfProfile: TypeOfProfile;
    atypicalTransports: AtypicalTransport[];
    recommendationPitch: string;
};

type GroupDeparture = {
    maxParticipants: number;
    minParticipants: number;
    travelPeriods: TravelPeriod[];
};

type TravelPeriod = {
    departureDate: YYYYMMDD;
    returnDate: YYYYMMDD;
    price: Price;
};

export const TOURISM_TYPE_NO_PLANE = 'no-plane';

type ItineraryServices = {
    otherIncludedServices: string[];
    otherNotIncludedServices: string[];
};

type FilterName =
    | 'duration'
    | 'price'
    | 'activity-type'
    | 'type'
    | 'environment-type'
    | 'type-of-profile'
    | 'guidance'
    | 'range';

type Filters = {
    type: 'choices' | 'min-max';
    name: FilterName;
    min?: number;
    max?: number;
    choices: Array<{
        name: string;
        translation: string;
    }>;
};

export type ItinerariesListAvailableFilters = {
    filters: Array<Filters>;
};
